import { View } from '@/components/ui/tw-wrappers';
import { useScenarioStore } from '@/stores/scenario-store';
import { ScenarioType } from '@/types/scenario';
import { ReactNode } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

type ScenarioItem = {
  type: ScenarioType;
  element: ReactNode;
};

export function ScenarioCardsRow({ scenarios }: { scenarios: ScenarioItem[] }) {
  const selectedScenarios = useScenarioStore(s => s.inputs.selectedScenarios);
  const visibleItems = scenarios.filter(s => selectedScenarios.includes(s.type));

  const len = visibleItems.length;
  const cardClass = len === 4 ? "w-full md:w-[48%] lg:w-[24%]" :
    len === 3 ? "w-full md:w-[47%] lg:w-[31%]" :
      len === 2 ? "w-full md:w-[48%]" : "w-full";

  return (
    <Animated.View entering={FadeIn.delay(200)} exiting={FadeOut} style={styles.wrap}>
      {visibleItems.map(({ type, element }) => (
        <View key={type} className={cardClass}>
          {element}
        </View>
      ))}
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 12,
  },
  button: {
    alignSelf: 'flex-start',
  },
  wrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    justifyContent: 'space-between',
  },
});
